import { createSlice } from '@reduxjs/toolkit';
import { productGalleryTitleList } from './productGalleryTitleAsyncThunk';

const productGalleryTitleListSlice = createSlice({
  name: "productGalleryTitle",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productGalleryTitleList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productGalleryTitleList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [productGalleryTitleList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productGalleryTitleListSlice.reducer;